export default {
  en: {
    login: "Sign In",
    email: "Email",
    password: "Password",
    reset_password: "Forgot Password?",
    reset_password_title: "Reset Password",
    no_account_message: "New to PM AutoTwin?",
    signup: "Sign Up",
    go_to_signup: "Sign Up Now",

    verify: "Verify",
    send: "Send Code",
    verify_code_input: "Verification Code",
    password_info: "(8+ characters with letters, numbers & symbols)",
    new_password: "New Password",
    password_check: "Confirm Password",
    password_change: "Update Password",
    go_to_login: " Back to Sign In",

    required: "*",
    optional: "(optional)",
    personal_term: "I agree to the Terms",
    privacy_term: "I agree to the Privacy Policy",
    marketing_term: "Send me product updates and announcements",

    already_account_message: "Already have an account?",


    or_label: "or",

  },
  ko: {
    login: "로그인",
    email: "이메일",
    password: "비밀번호",
    reset_password: "비밀번호 재설정",
    reset_password_title: "비밀번호 재설정",
    no_account_message: "아직 계정이 없으신가요?",
    signup: "회원가입",
    go_to_signup: "회원가입",

    verify: "인증",
    send: "전송",
    verify_code_input: "인증번호 입력",
    password_info: "(영문, 숫자, 특수문자 포함 8자 이상)",
    new_password: "새 비밀번호",
    password_check: "비밀번호 확인",
    password_change: "비밀번호 변경",
    go_to_login: "로그인 화면",

    required: "(필수)",
    optional: "(선택)",
    personal_term: "이용약관에 동의합니다.",
    privacy_term: "개인정보처리방침에 동의합니다.",
    marketing_term: "마케팅 정보 수신에 동의합니다.",

    already_account_message: "이미 계정이 있으신가요?",


    or_label: "또는",

  },
  ja: {
    login: "ログイン",
    email: "イメールアドレス",
    password: "パスワード",
    reset_password: "パスワード再設定",
    reset_password_title: "パスワード再設定",
    no_account_message: "まだアカウントをお持ちではありませんか?",
    signup: "会員登録",
    go_to_signup: "会員登録",

    verify: "認証",
    send: "確認",
    verify_code_input: "認証番号入力",
    password_info: "(英文、数字、特殊文字を含む8文字以上)",
    new_password: "パスワード",
    password_check: "パスワード確",
    password_change: "パスワード変更",
    go_to_login: "ログイン画面",

    required: "(必須)",
    optional: "(選択)",
    personal_term: "利用約款に同意します。",
    privacy_term: "個人情報処理方針に同意します",
    marketing_term: "マーケティング情報受信に同意します。",

    already_account_message: "このアカウントをお持ちですか?",


    or_label: "or",
  },
};
